// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/dist/cjs.js??ref--13-1!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??ref--13-2!../../node_modules/sass-loader/dist/cjs.js??ref--13-3!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./InitiativeGallery.vue?vue&type=style&index=0&id=79c8fb06&lang=scss&scoped=true&");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("6d446870", content, true, {});